"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activities.panel.all': 'Tutte le attività',
    'activities.panel.telegram': 'Telegram',
    'activities.panel.whatsapp': 'WhatsApp',
    'activities.panel.noLogs': 'Nessuna attività da visualizzare.',
    'activities.panel.noData': 'Nessun dato canale disponibile.',
    'activities.panel.groups': 'Gruppi',
    'activities.panel.channels': 'Canali/Gruppi',
    'activities.panel.inboxes': 'Caselle',
    'activities.panel.trackingEnabled': 'Tracciamento attivo',
    'activities.panel.connectionActive': 'Connessione attiva',
    'activities.panel.critical': 'Critico',
    'activities.panel.criticalDetected': 'Critico rilevato',
    'activities.panel.noAlerts': 'Nessun avviso',
    'activities.panel.requiresAction': 'Richiede azione',
    'activities.panel.spamQueue': 'Spam/Coda',
    'activities.panel.warning': 'Avvertimento',
    'activities.panel.noWarnings': 'Nessun avvertimento',
    'activities.panel.status': 'Stato',
    'activities.panel.status.good': 'Buono',
    'activities.panel.status.warning': 'Avvertimento',
    'activities.panel.status.danger': 'Pericolo',
    'activities.panel.lastSync': 'Ultima sincronizzazione',
    'activities.panel.neverSynced': 'Mai',
    'activities.panel.justNow': 'Proprio ora',
    'activities.panel.minutesAgo': 'min fa',
    'activities.panel.hoursAgo': 'h fa',
    'activities.panel.daysAgo': 'g fa',
};
